import React from 'react'
import Grid from '@material-ui/core/Grid'
import Listing from './Listing'
import Modal from './Modal'
import Input from './Input'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import User from 'EurestoClass/User'
import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {

  state = {
    open: this.props.open || false
  }

  onClick = (val, name) => {
    this.setState({
      open: false
    }, () => this.props.onClick(val, this.props.name))
  }

  handleModal = view => _ => {
    this.setState({
      open: view
    })
  }

  render () {
    return this.state.open && (this.props.modal || <Modal grid={{xs: this.props.xs || 6}} onClose={this.handleModal(false)} open={this.state.open}>
        <EurestoDiv title={this.props.title} paddingTopBody={0} buttonsLeft={this.props.buttonsLeft} buttonsRight={[{
          icon: ' ei-commun_fermer',
          className: 'EurestoError--text EurestoText',
          cb: this.handleModal(false)
        }]} style={Object.assign({
          //height: User.CalculHeight.getHeightWanted(70),
          maxHeight: User.CalculHeight.getHeightWanted(70)
        }, this.props.style || {})}>
          <Listing hideHeader={this.props.hideHeader} columns={this.props.columns} style={Object.assign({
            maxHeight: User.CalculHeight.getHeightWanted(70)
          }, this.props.style || {})} data={this.props.data} onClick={this.onClick}/>
        </EurestoDiv>
      </Modal>) ||
      <Grid container style={{ margin: 0 }} spacing={0}>
        <Grid item xs style={{
          width: '100%',
          margin: 0,
          //padding: '0px 5px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'visible',
          textAlign: 'left'
        }}>
          <Input
            key={Utils.getRandomNumber()}
            className="cursor-pointer EurestoPrimary--text"
            title={this.props.title}
            style={this.props.inputStyle || {}}
            onClick={this.handleModal(true)}
            value={this.props.libelle || ''}
            InputProps={{
              startAdornment: (
                <i style={{ zIndex: 3, marginLeft: 2.5 }} className={'ei-commun_rechercher'}/>
              ),
              endAdornment: (
                this.props.value && <i onClick={(e) => e.stopPropagation() || this.props.onClick(undefined, this.props.name)} style={{ zIndex: 3, marginRight: 7.5 }} className={'ei-commun_fermer EurestoError--text cursor-pointer'}/>
              )
            }}
          /></Grid>
      </Grid>
  }
}



// WEBPACK FOOTER //
// ./app/Components/ListingModal.js